<template>
    <div class="editor-container">
        <div class="editor-container_btnView">
          <div class="editor-container_btn" @click="handleSave">
            <i class="iconfont icon-copybaocun"></i>
            <span>保存</span>
          </div>
          <div class="editor-container_btn" @click="handleCopy">
            <i class="el-icon-document-copy"></i>
            <span>复制</span>
          </div>
          <div class="editor-container_btn" @click="handeleClose">
            <i class="iconfont icon-copyzuixiaohua"></i>
          </div>
        </div>
        <Toolbar
          style="border-bottom: 1px solid #ccc"
          :editor="editor"
          class="editor-container_toolbar"
          :defaultConfig="toolbarConfig"
          :mode="mode"
        />
        <Editor
          style="height: 500px; overflow-y: hidden;"
          v-model="editorContent"
          :defaultConfig="editorConfig"
          :mode="mode"
          @onCreated="handleCreated"
        />
    </div>
</template>
<script>
  import Vue from 'vue'
  import { Editor, Toolbar } from '@wangeditor/editor-for-vue'
  import '@wangeditor/editor/dist/css/style.css'

  export default Vue.extend({
    components: { Editor, Toolbar },
    data() {
      return {
        editor: null,
        editorContent: '',
        toolbarConfig: {
          excludeKeys: [
            'uploadVideo', // 单个菜单
            'fullScreen', // 全屏
            'codeBlock', // 代码块
            'group-image', // 图片菜单组
            'group-video', // 视频菜单组
            'insertLink', // 链接
            'insertTable', // 表格
            'undo', // 撤销
            'redo', // 重做   
            'blockquote', // 引用
            'divider', // 分割线
            'emotion', // 表情
            'todo', // 待办事项
          ]
        },
        editorConfig: { 
          placeholder: '请输入内容...' ,
          readOnly: false, // 只读模式
          scroll: true, // 允许滚动
        },
        mode: 'default',
      }
    },
    methods: {
      // 内容变化时触发
      onChange(editor) {
        console.log('内容变化', editor.getHtml())
      },
      // 编辑器销毁
      onDestroyed(editor) {
        
      },
      // 获得焦点
      onFocus(editor) {
        
      },
      // 失去焦点
      onBlur(editor) {
        
      },

      // 创建编辑器
      handleCreated(editor) {
        this.editor = Object.seal(editor)
      },

      // 保存内容
      async handleSave() {
        const editor = this.editor
        if (!editor) return
        // 1. 获取富文本HTML（存数据库用这个）
        const content = editor.getHtml()
        // 2. 获取纯文本（摘要/字数用）
        const text = editor.getText()
        console.log('HTML内容：', content)
        console.log('纯文本：', text)
        // 👉 在这里调后端接口提交保存
        /*
        await axios.post('/api/article/save', {
          content: content,
          summary: text.slice(0, 100)
        })
        alert('保存成功')
        */
      },

      // 重置内容
      handleReset() {
        this.editorContent = ''
        this.editor.setHtml('')
      },

      // 复制内容
      handleCopy() {
        const editor = this.editor
        if (!editor) return
        const content = editor.getHtml()
        const text = editor.getText()
        console.log('HTML内容：', content)
        console.log('纯文本：', text)
        navigator.clipboard.writeText(content)
      },

      // 关闭编辑器
      handeleClose() {
        this.$emit('close')
      },
    },
    mounted() {
      // 模拟 ajax 请求，异步渲染编辑器
      setTimeout(() => {
        this.editorContent = '好的！以下是一段随机生成的文字，供你参考：\n在春日的午后，阳光透过树叶洒下斑驳的光影，微风轻拂，带来远处花香与泥土的气息。城市的一隅，有人匆匆赶路，也有人驻足凝望——或许是在看一只停在窗台的蝴蝶，又或许只是想在这喧嚣中寻得片刻宁静。碳足迹虽无形，却与每个人的选择息息相关。少开一次车、多用一度绿电、随手关灯……点滴行动，终将汇聚成守护地球的力量。\n如果你有特定主题或用途（比如环保、低碳生活、文案创作等），也可以告诉我，我可以为你定制一段更贴合需求的文字！🌱'
      }, 1500)
    },
    beforeDestroy() {
      const editor = this.editor
      if (editor == null) return
      editor.destroy() // 组件销毁时，及时销毁编辑器
    },
  })
</script>
<style scoped>
.wangeditor-container {
    height: 500px;
}

.editor-container {
  width: 690px;
  height: calc(100vh - 24px);
  background-color: #fff;
  position: fixed;
  right: 12px;
  top: 12px;
  border-radius: 15px;
  box-shadow: -3px 4px 15px 0px rgba(147, 169, 167, 0.2);
}

.editor-container_btnView {
  margin: 0 20px;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

.editor-container_btn{
  width: max-content;
  padding: 0 12px;
  height: 40px;
  text-align: center;
  border-radius: 5px;
  cursor: pointer;
  font-size: 16px;
  line-height: 40px;
  color: #060a26;
}

.editor-container_btn i{
  margin-right: 4px;
}

.editor-container_btn:hover{
  background-color: rgba(6,10,38,.06);
}
</style>
